export default __webpack_public_path__ + "static/media/medicamentos.a1b9bfe7.svg";